const customFilter = (object, result, key, value, returnValues) => {
  if (
    Object.prototype.hasOwnProperty.call(object, key) &&
    object[key] === value
  ) {
    result.push(object[returnValues]);
  }

  Object.keys(object).forEach(el => {
    if (typeof object[el] === 'object') {
      customFilter(object[el], result, key, value, returnValues);
    }
  });
};

export const foundObjects = (object, key, value, returnValues) => {
  const result = [];
  customFilter(object, result, key, value, returnValues);

  return result;
};
